import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import VM from 'scratch-vm';

import Box from '../box/box.jsx';
import Modal from '../../containers/modal.jsx';
import CodeLibraryBlockPreview from './code-library-block-preview.jsx';

import getCodeLibraryExamples from '../../lib/code-library-examples';

import styles from './code-library-modal.css';

const CodeLibraryModal = props => {
    const examples = getCodeLibraryExamples(props.vm);

    const handleInsertExample = example => {
        props.vm.runtime.emit('CODE_LIBRARY_INSERT', example);
        props.onRequestClose();
    };

    return (
        <Modal
            className={styles.modalContent}
            contentLabel={
                <FormattedMessage
                    defaultMessage="Kodebibliotek"
                    description="Titel på kodebibliotekets modal"
                    id="gui.codeLibrary.title"
                />
            }
            headerClassName={styles.header}
            onRequestClose={props.onRequestClose}
        >
            <Box className={styles.body}>
                <div className={styles.intro}>
                    <FormattedMessage
                        defaultMessage="Tryk på et kodeeksempel for at sætte det direkte ind i din kode."
                        description="Kort forklaring øverst i kodebiblioteket"
                        id="gui.codeLibrary.intro"
                    />
                </div>
                <div className={styles.exampleGrid}>
                    {examples.map(example => (
                        <button
                            key={example.id}
                            className={styles.exampleCard}
                            onClick={() => handleInsertExample(example)}
                            type="button"
                        >
                            <div className={styles.exampleTitle}>{example.title}</div>
                            <div className={styles.exampleDescription}>{example.description}</div>
                            <div className={styles.preview}>
                                <CodeLibraryBlockPreview
                                    blocksMediaPath={props.blocksMediaPath}
                                    className={styles.previewWorkspace}
                                    locale={props.locale}
                                    vm={props.vm}
                                    xml={example.xml}
                                />
                            </div>
                        </button>
                    ))}
                </div>
            </Box>
        </Modal>
    );
};

CodeLibraryModal.propTypes = {
    blocksMediaPath: PropTypes.string.isRequired,
    locale: PropTypes.string,
    onRequestClose: PropTypes.func.isRequired,
    vm: PropTypes.instanceOf(VM).isRequired
};

CodeLibraryModal.defaultProps = {
    locale: 'da'
};

export default CodeLibraryModal;
